import React, { Component } from "react";
import ItemHp from "../../../components/ItemHp/ItemHp";
import Hammer from "hammerjs";

import "./Homepage.scss";
import { withTranslation } from "react-i18next";
const ITEM_HEIGHT = 140;

class ItemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.items,
      activeSlide: 0,
      animating: false,
      nbrItems: 0,
      hammerSlider: null,
    };
  }

  componentDidMount() {
    this.hammerSliderFunc(this.props.items);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items !== this.props.items) {
      if (this.state.hammerSlider) {
        this.state.hammerSlider.destroy();
      }
      this.setState({ items: this.props.items });
      this.hammerSliderFunc(this.props.items);
    }
  }

  componentWillUnmount() {
    if (this.state.hammerSlider) {
      this.state.hammerSlider.destroy();
    }
  }

  /**
   * Change la height de l'item au scroll
   */
  heightOnScroll = (index, scrollRatio, nbrItems) => {
    // Position optimale de l'element par rapport a la fenetre et le nombre d'element
    const perfectRatio = index / nbrItems;
    const step = 1 / nbrItems;
    const offsetRatio = Math.abs(scrollRatio - perfectRatio);
    if (offsetRatio < step) {
      return (step - offsetRatio) / step;
    } else {
      return 0;
    }
  };

  /**
   * Utilisation de Hammer pour les actualités en homepage
   */
  hammerSliderFunc = (items) => {
    let sliderEl = document.querySelector("#items_list");

    // Récupération du nombre d'items recu
    this.setState({ nbrItems: items.length });
    // Initialisation d'Hammer
    this.setState({ hammerSlider: new Hammer.Manager(sliderEl) }, () => {
      this.state.hammerSlider.add(
        new Hammer.Pan({
          threshold: 0,
          pointers: 0,
          direction: Hammer.DIRECTION_VERTICAL,
        })
      );

      // Détection du pan sur la liste d'item
      this.state.hammerSlider.on("pan", (e) => {
        const { activeSlide, animating, nbrItems } = this.state;
        // Déjà une anim on stop
        if (animating) {
          return;
        }

        e.preventDefault();
        // if (e.eventType !== Hammer.INPUT_MOVE) return;
        // if (e.srcEvent.type !== "pointercancel") {
        // Ratio du scroll par rapport à la fenetre
        let translate = Math.min(-activeSlide * ITEM_HEIGHT + e.deltaY, 0);
        let scrollRatio = Math.abs(translate) / ((nbrItems - 1) * ITEM_HEIGHT);

        sliderEl.style.transform = "translateY(" + translate + "px)";

        const newItems = items.map((elem, index) => {
          return {
            ...elem,
            size: this.heightOnScroll(index, scrollRatio, nbrItems - 1),
          };
        });
        this.setState({ items: newItems });

        if (Math.abs(e.deltaY) >= ITEM_HEIGHT) {
          if (e.deltaY > 0) {
            this.goToSlide(activeSlide - 1);
          } else {
            this.goToSlide(activeSlide + 1);
          }

          // stop anim
          return;
        }
        if (e.isFinal) {
          if (e.deltaY < -30) this.goToSlide(activeSlide + 1);
          else if (e.deltaY > 30) this.goToSlide(activeSlide - 1);
          else this.goToSlide(activeSlide);
        }
        this.setState({ anim: false });
        // }
      });
    });
  };

  goToSlide = (number) => {
    this.setState(
      {
        animating: true,
      },
      () => {
        const sliderEl = document.querySelector("#items_list");

        if (number < 0) {
          number = 0;
        } else if (number > this.state.nbrItems - 1) {
          number = this.state.nbrItems - 1;
        }

        this.state.hammerSlider.stop();
        let scrollRatio = number / (this.state.nbrItems - 1);
        const newItems = this.state.items.map((elem, index) => {
          return {
            ...elem,
            size: this.heightOnScroll(
              index,
              scrollRatio,
              this.state.nbrItems - 1
            ),
          };
        });

        this.setState({
          activeSlide: number,
          animating: false,
          items: newItems,
        });
        const translate = -ITEM_HEIGHT * number;
        sliderEl.style.transform = "translateY(" + translate + "px)";
      }
    );
  };

  render() {
    const { items } = this.state;
    if (items?.length > 0)
      return (
        <ul id="items_list">
          {items.map((item) => (
            <li key={item.id + "-" + item.title} className="item">
              <ItemHp
                key={item.id + "-" + item.title}
                background={item.picture}
                logo={item.brand.logo}
                type={item.type}
                title={item.title}
                brand={item.brand}
                size={item.size}
                id={item.id}
                brandId={item.brand_id}
                youtubeId={item.youtubeId}
              />
            </li>
          ))}
        </ul>
      );
  }
}

export default withTranslation()(ItemList);
